import { Button } from '@features/ui';
import { UserTable } from '@features/admin/settings';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { canAccess } from '@src/utils/auth';
import { useAuthStore } from '@src/stores/authStore';
import { UserRolePermission } from '@src/types/settings';

export const Settings = () => {
  const { auth } = useAuthStore();
  const navigate = useNavigate();
  const handleEditUser = useCallback(
    (user: any) => {
      navigate(`/admin/settings-user/${user.id}`, { state: { user } });
    },
    [navigate]
  );

  const handleCreateUser = useCallback(() => {
    navigate(`/admin/settings-user/create`);
  }, [navigate]);

  return (
    <div className={'flex flex-col gap-y-8'}>
      <div className={'flex items-center justify-between gap-x-2'}>
        <h1 className={'text-[23px]'}>Admin Users</h1>
        {canAccess(
          UserRolePermission.MANAGE_USERS,
          auth?.user?.permissions
        ) && (
          <Button size={'sm'} variant={'lime'} onClick={handleCreateUser}>
            Create
          </Button>
        )}
      </div>
      <UserTable onEdit={handleEditUser} />
    </div>
  );
};
